// extracted by mini-css-extract-plugin
export var label = "_il-2";
export var slideContainer = "_il-0";
export var slider = "_il-1";